export function createReducer(initialState, handlersTable) {
  return function (state = initialState, action) {
    if (handlersTable.hasOwnProperty(action.type)) {
      return handlersTable[action.type](state, action);
    } else {
      return state;
    }
  };
}

/**
 * Memoize a pure function on its last arguments (compared by reference).
 * Use for derived-data selectors that must return a stable reference while
 * their inputs have not changed.
 */
export function memoizeLastCall(fn) {
  let lastArgs = null;
  let lastResult = null;
  return function (...args) {
    if (
      lastArgs !== null &&
      lastArgs.length === args.length &&
      args.every((arg, i) => arg === lastArgs[i])
    ) {
      return lastResult;
    }
    lastArgs = args;
    lastResult = fn(...args);
    return lastResult;
  };
}
